export const ENTRY_STORE = 'entry-store';
export const ENTRY_DECLINE = 'entry-decline';
export const GAME_PROFILE_DATA_CHANGED = 'game-profile-data-changed';
export const DATA_CHANGE = 'data-change';
export const SOCIAL_ACCOUNT_ATTACHED = 'social-account-attached';
export const TOOK_PART_TEAM = 'took-part-team';
export const SOCIAL_ACCOUNT_DETACHED = 'social-account-detached';
export const LEAVE_TEAM = 'leave-team';
export const VERIFICATION_PHONE_DETACHED = 'verification-phone-detached';
export const VERIFICATION_PHONE_ATTACHED = 'verification-phone-attached';
export const DELETE_FOR_TEAM = 'delete-for-team';
export const TOURNAMENT_CREATED = 'tournament-created';
export const TOURNAMENT_UPDATED = 'tournament-updated';
export const TOURNAMENT_DELETED = 'tournament-deleted';
export const GAME_PROFILE_ADDED = 'game-profile-added';
export const GAME_PROFILE_DELETED = 'game-profile-deleted';

export const CODES = {
    [ENTRY_STORE]: `Подана заявка на турнир`,
    [ENTRY_DECLINE]: `Заявка отозвана с турнира`,
    [GAME_PROFILE_DATA_CHANGED]: 'Изменены данные игрового профиля',
    [DATA_CHANGE]: 'Изменены данные',
    [SOCIAL_ACCOUNT_ATTACHED]: 'Пользователь привязал соц. сеть',
    [SOCIAL_ACCOUNT_DETACHED]: 'Пользователь отвязал соц. сеть',
    [TOOK_PART_TEAM]: 'Пользователь вступил в команду',
    [LEAVE_TEAM]: 'Пользователь покинул команду',
    [DELETE_FOR_TEAM]: 'Пользователь был удален из команды',
    [VERIFICATION_PHONE_DETACHED]: 'Пользователь отвязал номер',
    [VERIFICATION_PHONE_ATTACHED]: 'Пользователь привязал номер',
    [TOURNAMENT_CREATED]: 'Пользователь создал турнир',
    [TOURNAMENT_UPDATED]: 'Пользователь обновил турнир',
    [TOURNAMENT_DELETED]: 'Пользователь удалил турнир',
    [GAME_PROFILE_ADDED]: 'Игровой профиль добавлен',
    [GAME_PROFILE_DELETED]: 'Игровой профиль удалён',
};






